import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

// get projects for show on admin dashboard

export const updateAdQuatation = createAsyncThunk(
    "/admin/update-admin-quotation",
    async ({ id, payload }) => {

        try {
            const myurl = `${V_URL}/believe/update-quotation/${id}`;
            const response = await axios({
                method: "post",
                url: myurl,
                data: payload,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("VA_TOKEN"),
                },
            });

            const data = response.data;
            // console.log(data, "adminGetEmployee response");

            if (data.success === true) {
                return data;
            } else {
                throw new Error(data);
            }
        } catch (error) {
            console.log(error, "error");
            toast.error(error.response.data.message);
            return error;
        }
    }
);

const updateAdQuatationSlice = createSlice({
    name: "updateAdQuatation",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(updateAdQuatation.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateAdQuatation.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(updateAdQuatation.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default updateAdQuatationSlice.reducer;
